export const serverDefaultCfg = {
  baseURL: process.env.VUE_APP_SERVER_HOST, // 请求基础地址,可根据环境自定义
  mockURL: '',
};
